import { intl } from '@shared';

export const formatLabel = field =>
  intl.formatMessage({ id: `LongCruiseForm.${field}.label` });
export const formatPlaceholder = field =>
  intl.formatMessage({ id: `LongCruiseForm.${field}.placeholder` });
